export const I18N_PROFILE_CONTEXT = 'profile';
export const VIDEO_SHOUTOUT = 'video-shoutout';
export const AUDIO_SHOUTOUT = 'audio-shoutout';
export const INSTRUCTION = 'instruction';
export const FORM_BUTTON = 'form-button';
export const TEXT_ONE = 'text-one';
export const TEXT_TWO = 'text-two';
export const BADGE = 'badge';
export const REQUEST_LIMIT_COUNT = 'request-limit';
export const PER_MESSAGE = 'per-message';
export const REQUESTS_LEFT = 'requests-left';
export const DURATION = 'duration';
export const DURATION_VALUE = 'duration-value';
export const RESPONDS_IN = 'responds-in';
export const RESPONDS_IN_VALUE = 'responds-in-value';
export const FIRST_TO_KNOW = 'first-to-know';
export const SOLD_OUT = 'sold-out';
export const AVAILABLE_IN = 'available-in';
export const NOTIFY_ME = 'notify-me.text';
export const NOTIFY_ME_LABEL = 'notify-me.label';
export const NOTIFY_ME_PLACEHOLDER = 'notify-me.placeholder';
export const NOTIFY_ME_ERROR = 'notify-me.error';
export const NOTIFY_ME_BUTTON = 'notify-me.button';
export const NOTIFIED = 'notified';
export const EMAIL_REMINDER_TITLE_DEFAULT = `email-reminder.title.default`;
export const EMAIL_REMINDER_TITLE_USERNAME = `email-reminder.title.username`;
export const EMAIL_REMINDER_TEXT = `email-reminder.text`;
export const SOLD_OUT_TITLE = 'sold-out-message.title';
export const SOLD_OUT_TEXT = (messageType: string): string => `sold-out-message.text.${messageType !== '' ? `default` : `both`}`;
export const SOLD_OUT_BUTTON_1 = 'sold-out-message.button-one';
export const SOLD_OUT_BUTTON_2 = 'sold-out-message.button-two';
export const SOLD_OUT_VIDEO = 'video';
export const SOLD_OUT_VOICE = 'audio';
export const SHARING_TITLE = 'sharing-title';
export const ACTION_BUTTON = (activeTab: string): string => `action-button.${activeTab}`;
export const READ_MORE = `read-more`;
export const SEE_LESS = `see-less`;
